<template>
    <v-text-field
      class="input-field mb-7"
      :id="inputName"
      :value="inputValue"
      :type="inputType" 
      @focus="onInputFocus"
      @input="onInputChange" 
      color="black" 
      :rules="[() => !!inputValue || 'Este campo é obrigatório']" 
      :placeholder="placeholder" 
      :prepend-inner-icon="icon" 
      outlined
      >
      </v-text-field>
</template>

<script>
export default {
    name: "TextField",
    props: {
        placeholder: {
            type: String,
        },
        icon: {
            type: String,
            default: 'mdi-card-account-details'
        },
        inputType: {
          type: String,
          default: 'text'
        },
        inputs: {
          type: Object,
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        inputName: {
            type: String
        }
    },
    data() {
        return {
            code: ''
        }
    },
    computed: {
        inputValue: function () {
            return this.inputs[this.inputName];
        }
    },
    methods: {
        onInputChange(input) {
            this.$emit('onInputChange', input)
        },
        onInputFocus(input) {
            this.$emit('onInputFocus', input)
        },
    }
}
</script>